var _defs, _clipPath, _defs2, _clipPath2, _defs3, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElasticCloudIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 2500,
  height: 2500,
  viewBox: "0 0 80 80"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "elastic-cloud-icon_svg__a",
  d: "M40 72C22.4 72 8 57.6 8 40S22.4 8 40 8s32 14.4 32 32-14.4 32-32 32m0-40.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5"
}))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "elastic-cloud-icon_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#elastic-cloud-icon_svg__a",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 9.2,
  cy: 39.9,
  r: 32,
  style: {
    clipPath: "url(#elastic-cloud-icon_svg__b)",
    fill: "#353535"
  }
}), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "elastic-cloud-icon_svg__c",
  d: "M40 72C22.4 72 8 57.6 8 40S22.4 8 40 8s32 14.4 32 32-14.4 32-32 32m0-40.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5"
}))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "elastic-cloud-icon_svg__d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#elastic-cloud-icon_svg__c",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 5,
  r: 26.5,
  style: {
    clipPath: "url(#elastic-cloud-icon_svg__d)",
    fill: "#07a5de"
  }
}), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "elastic-cloud-icon_svg__e",
  d: "M40 72C22.4 72 8 57.6 8 40S22.4 8 40 8s32 14.4 32 32-14.4 32-32 32m0-40.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5"
}))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "elastic-cloud-icon_svg__f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#elastic-cloud-icon_svg__e",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 75,
  r: 26.5,
  style: {
    clipPath: "url(#elastic-cloud-icon_svg__f)",
    fill: "#93c90e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 31.5c-2.3-8.4-7.9-15.4-15.4-19.5-2.9 1.6-5.5 3.7-7.8 6C21.4 26.1 30 31.5 40 31.5",
  style: {
    fill: "#0078a0"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 48.5c-10 0-18.6 5.5-23.2 13.6 2.2 2.3 4.8 4.4 7.7 5.9C32 63.9 37.7 56.9 40 48.5",
  style: {
    fill: "#74a300"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z",
  style: {
    fill: "none"
  }
}));
export { SvgElasticCloudIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";